<template>
    <div>
        <el-form :model="pushInfo" ref="pushForm" :rules="rules">
            <el-form-item label="中文标题" prop="titleZh">
                <el-input v-model="pushInfo.titleZh"></el-input>
            </el-form-item>
            <el-form-item label="英文标题" prop="titleEn">
                <el-input v-model="pushInfo.titleEn"></el-input>
            </el-form-item>
            <el-form-item label="中文内容" prop="contentZh">
                <el-input v-model="pushInfo.contentZh"></el-input>
            </el-form-item>
            <el-form-item label="英文内容" prop="contentEn">
               <el-input v-model="pushInfo.contentEn"></el-input>
            </el-form-item>
            <el-form-item label="APP跳转路径">
                <el-input v-model="pushInfo.jumpUrl"></el-input>
            </el-form-item>
            <el-form-item label="推送编号"  prop="pushNo">
                <el-input v-model="pushInfo.pushNo" disabled></el-input>
            </el-form-item>
        </el-form>
        <el-button type="primary" @click="pushArtificialRemind('pushForm')">确认推送</el-button>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    export default {
        name: "artificialRemind",
        data(){
            return{
                pushInfo:{
                    titleZh:'',
                    titleEn:'',
                    contentZh:'',
                    contentEn:'',
                    pushNo:'',
                    jumpUrl:''
                },
                rules: {
                    titleZh: [{required: true, message: '中文标题不能为空！'}],
                    titleEn: [{required: true, message: '英文标题不能为空！'}],
                    contentZh: [{required: true, message: '中文内容不能为空！'}],
                    contentEn: [{required: true, message: '英文内容不能为空！'}],
                    pushNo: [{required: true, message: '推送编号不能为空！'}],
                }
            }
        },
        methods:{
            ...mapActions('pushSetting',['pushChinese','pushEnglish']),
            pushArtificialRemind(pushForm){
                this.$refs[pushForm].validate(valid =>{
                    if (valid){
                        this.pushChinese(this.pushInfo).then(response => {
                            this.$message({
                                message: response.data,
                                type: 'success'
                            })
                            this.pushEnglish(this.pushInfo).then(response => {
                                this.$message({
                                    message: response.data,
                                    type: 'success'
                                })
                                this.$refs[pushForm].resetFields();
                                this.getPushNo();
                            })
                        });
                    }
                })

            },
            getPushNo(){
                this.pushInfo.pushNo = new Date().getTime();
            }
        },
        created() {
            this.getPushNo();
        }
    }
</script>

<style scoped>

</style>